






















































































































































































import { Vue, Component } from 'vue-property-decorator'
import ClockEvents from '@/components/ClockEvents.vue'
import GMap from '@/components/GMap.vue'
import JobPreview from '@/components/JobPreview.vue'
import UserPreview from '@/components/UserPreview.vue'
import { loadPayment } from '@/services/payments'
import { loadShift } from '@/services/shifts'
import { loadJob } from '@/services/jobs'
import { isDebit, isUser, statusColor } from '@/types/Payments'
import { clockedTime, breakTime, workTime, ClockEvent } from '@/types/Jobs'
import EditPaymentDialog from './EditPaymentDialog.vue'
import CompletePaymentsDialog from './CompletePaymentsDialog.vue'
import DenyPaymentsDialog from './DenyPaymentsDialog.vue'
import { currentUserIs, Managers, UserRole } from '@/types/Users'

@Component({
  metaInfo: {
    title: 'Payment',
  },
  components: {
    ClockEvents,
    GMap,
    JobPreview,
    UserPreview,
    EditPaymentDialog,
    CompletePaymentsDialog,
    DenyPaymentsDialog,
  }
})
export default class Payment extends Vue {

  loading = false
  editPaymentDialog = false
  completePaymentsDialog = false
  denyPaymentsDialog = false

  async mounted() {
    this.loading = true
    const payment = await loadPayment(this.$store, this.$route.params.paymentId)
    this.loading = false
    
    if (payment?.invoice?.timecard?.shift_id) {
      const shift = await loadShift(this.$store, payment.invoice.timecard.shift_id)
      const job = await loadJob(this.$store, shift.job_id)
    }
  }

  get payment() {
    return this.$store.getters.payment(this.$route.params.paymentId)
  }

  get shift() {
    if (!this.payment?.invoice?.timecard) return null
    return this.$store.getters.shift(this.payment.invoice.timecard.shift_id)
  }

  get job() {
    const jobId = this.shift?.job_id || this.payment?.invoice?.job_id
    return this.$store.getters.job(jobId)
  }

  get balance() {
    return this.$store.state.payments.balance
  }

  get hasSufficientBalance() {
    return this.balance.value >= this.payment.total
  }

  get history() {
    if (!this.shift || !this.shift.clock_history) return []
    return this.shift.clock_history
      .sort((a: ClockEvent, b: ClockEvent) => {
        return (new Date(b.time)).getTime() - (new Date(a.time)).getTime()
      })
      .filter((event: ClockEvent) => {
        return event.timecard_id === this.payment?.invoice?.timecard.id
      })
  }

  get workTime() {
    if (!this.shift) return null
    return workTime(this.history)
}

  get clockedTime() {
    if (!this.shift) return null
    return clockedTime(this.history)
  }
  
  get breakTime() {
    if (!this.shift) return null
    return breakTime(this.history)
  }

  get isDebit() {
    return isDebit(this.payment)
  }

  get userIsManager() {
    return currentUserIs(...Managers)
  }

  get userIsContractor() {
    return currentUserIs(UserRole.Contractor)
  }

  get receiverIsUser() {
    return isUser(this.payment.receiver)
  }

  goBack() {
    this.$router.push({ name: 'payments' })
  }

  statusColor(status: string) {
    return statusColor(status)
  }
}
